.wrapper {
  position: relative;
  height: var(--current-subheader-height);
  overflow: visible;
  transition: height 300ms ease-in;
  padding: 0px 20px 0px 0px;
}

.content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  transition: opacity 300ms ease-in;
}

.content-collapsed {
  opacity: 0;
  pointer-events: none;
}

.collapse-btn {
  position: absolute;
  left: 28px;
  bottom: -4px;
  transform: translateY(50%);
  transition: bottom 300ms ease-in;
}

.collapse-btn-down {
  bottom: -8px;
}

.title {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  color: var(--color-neutral-600);
  margin-left: 20px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2FnZW50L193b3JrLzE0L3Mvc2VudGluZWwtZnJvbnQvc3JjL3BhZ2VzL0Rhc2hib2FyZC9mcmFnbWVudHMvSGVhZGVyIiwic291cmNlcyI6WyJIZWFkZXIubW9kdWxlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiLndyYXBwZXIge1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIGhlaWdodDogdmFyKC0tY3VycmVudC1zdWJoZWFkZXItaGVpZ2h0KTtcbiAgb3ZlcmZsb3c6IHZpc2libGU7XG4gIHRyYW5zaXRpb246IGhlaWdodCAzMDBtcyBlYXNlLWluO1xuICBwYWRkaW5nOiAwcHggMjBweCAwcHggMHB4O1xufVxuXG4uY29udGVudCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgZmxleDogMTtcbiAgdHJhbnNpdGlvbjogb3BhY2l0eSAzMDBtcyBlYXNlLWluO1xufVxuXG4uY29udGVudC1jb2xsYXBzZWQge1xuICBvcGFjaXR5OiAwO1xuICBwb2ludGVyLWV2ZW50czogbm9uZTtcbn1cblxuLmNvbGxhcHNlLWJ0biB7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgbGVmdDogMjhweDtcbiAgYm90dG9tOiAtNHB4O1xuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoNTAlKTtcbiAgdHJhbnNpdGlvbjogYm90dG9tIDMwMG1zIGVhc2UtaW47XG59XG5cbi5jb2xsYXBzZS1idG4tZG93biB7XG4gIGJvdHRvbTogLThweDtcbn1cblxuLnRpdGxlIHtcbiAgZm9udC1zaXplOiB2YXIoLS1mb250LXNpemUtbWQpO1xuICBmb250LXdlaWdodDogdmFyKC0tZm9udC13ZWlnaHQtbWVkaXVtKTtcbiAgY29sb3I6IHZhcigtLWNvbG9yLW5ldXRyYWwtNjAwKTtcbiAgbWFyZ2luLWxlZnQ6IDIwcHg7XG59Il19 */